import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { LayoutDashboardIcon, SearchIcon, ClockIcon, InboxIcon, CheckSquareIcon, WalletIcon, ShieldIcon, FileTextIcon, BellIcon } from 'lucide-react';
export interface MenuItem {
  text: string;
  icon: React.ReactNode;
  path: string;
  roles?: string[];
}
export interface MenuGroup {
  title: string;
  items: MenuItem[];
}
const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    isAuthenticated,
    isAuthInitialized,
    user
  } = useAuth();
  const navigate = useNavigate();
  const menuGroups: MenuGroup[] = [{
    title: 'MAIN',
    items: [{
      text: 'Dashboard',
      icon: <LayoutDashboardIcon size={20} data-id="element-821" />,
      path: '/'
    }, {
      text: 'Lookup',
      icon: <SearchIcon size={20} data-id="element-822" />,
      path: '/transaction-lookup',
      roles: ['maker', 'admin']
    }]
  }, {
    title: 'TRANSACTIONS',
    items: [{
      text: 'History',
      icon: <ClockIcon size={20} data-id="element-823" />,
      path: '/history'
    }, {
      text: 'Maker Inbox',
      icon: <InboxIcon size={20} data-id="element-824" />,
      path: '/transaction-approval-history',
      roles: ['maker', 'admin']
    }, {
      text: 'Checker Inbox',
      icon: <CheckSquareIcon size={20} data-id="element-825" />,
      path: '/transaction-approval',
      roles: ['checker', 'admin']
    }]
  }, {
    title: 'MANAGEMENT',
    items: [{
      text: 'Float & Balance',
      icon: <WalletIcon size={20} data-id="element-826" />,
      path: '/float-balance'
    }, {
      text: 'Users',
      icon: <ShieldIcon size={20} data-id="element-827" />,
      path: '/branch-users',
      roles: ['admin']
    }]
  }, {
    title: 'REPORTS',
    items: [{
      text: 'Reports',
      icon: <FileTextIcon size={20} data-id="element-828" />,
      path: '/reports'
    }, {
      text: 'Notifications',
      icon: <BellIcon size={20} data-id="element-829" />,
      path: '/notifications'
    }]
  }];
  // Filter menu items based on user role
  const filteredMenuGroups = menuGroups.map(group => ({
    ...group,
    items: group.items.filter(item => {
      if (!item.roles) return true;
      return item.roles.includes(user?.role || '');
    })
  })).filter(group => group.items.length > 0);
  useEffect(() => {
    if (isAuthInitialized && !isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, isAuthInitialized, navigate]);
  if (!isAuthInitialized) {
    return null;
  }
  if (!isAuthenticated) {
    return null;
  }
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden'
  }} data-id="element-830">
      <Navbar onMenuClick={() => setSidebarOpen(true)} data-id="element-831" />
      <Box sx={{
      display: 'flex',
      flexGrow: 1,
      overflow: 'hidden'
    }} data-id="element-832">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} menuGroups={filteredMenuGroups} data-id="element-833" />
        <Box component="main" sx={{
        flexGrow: 1,
        overflow: 'auto',
        bgcolor: 'background.default'
      }} data-id="element-834">
          <Outlet data-id="element-835" />
        </Box>
      </Box>
    </Box>;
};
export default Layout;